import { bindActionCreators } from 'redux'
import { checkSession } from '../actions'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import React from 'react'
import { DivContentBox, DivTitleBox } from '../components/common/styled'
import SelfieCheckComponent from '../components/selfie-check/selfieCheckComponent'

const SelfieCheck = ({ approximateItemsInQueue }) => (
  <div className='ibox float-e-margins animated fadeIn section-shadow'>
    <DivTitleBox className='ibox-title'>
      <div className='row'>
        <div className='col-xs-12 col-sm-12'>
          <h2>
            Face Confirmation
            {`${
              approximateItemsInQueue > 0 ? `: Approximate Items Remaining in Queue ${approximateItemsInQueue}` : ''
            }`}
          </h2>
        </div>
      </div>
    </DivTitleBox>
    <DivContentBox className='ibox-content animated fadeIn'>
      <SelfieCheckComponent />
    </DivContentBox>
  </div>
)

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  approximateItemsInQueue: state.getAgentBatch.approximateItemsInQueue,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkSession,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SelfieCheck))
